import { TOP_PAGE_MODE, getTopPageMode, setTopPageMode, applyModeToBody } from '../shared/top_page_mode';
import { getSidebarDrawerController, initializeSidebarDrawer } from '../shared/sidebar_drawer';

const initializeTopToggle = () => {
  const toggleButtons = document.querySelectorAll('.js-top-page-toggle');
  if (!toggleButtons.length) {
    return;
  }

  const legacySelector = toggleButtons[0].getAttribute('data-target-legacy');
  const improvedSelector = toggleButtons[0].getAttribute('data-target-improved');
  if (!legacySelector || !improvedSelector) {
    return;
  }

  const legacy = document.querySelector(legacySelector);
  const improved = document.querySelector(improvedSelector);
  if (!legacy || !improved) {
    return;
  }

  const storedMode = getTopPageMode();
  const hashIndicatesImproved = window.location.hash === '#improvedTopPage';
  const hashTargetsLegacy = window.location.hash === '#legacyTopPage';
  const params = new URLSearchParams(window.location.search);
  const modeParam = params.get('top_page_mode');
  const contentParam = params.get('top_page_content');
  const paramMode =
    modeParam === TOP_PAGE_MODE.IMPROVED || modeParam === TOP_PAGE_MODE.LEGACY
      ? modeParam
      : null;
  let forceLegacyContent = contentParam === 'legacy' || hashTargetsLegacy;

  let showImproved =
    toggleButtons[0].dataset.state === 'on' ||
    hashIndicatesImproved ||
    storedMode === TOP_PAGE_MODE.IMPROVED;

  if (paramMode) {
    showImproved = paramMode === TOP_PAGE_MODE.IMPROVED;
  }
  const applyState = () => {
    const shouldShowLegacy = !showImproved || forceLegacyContent;
    const shouldShowImproved = showImproved && !forceLegacyContent;

    legacy.style.display = shouldShowLegacy ? '' : 'none';
    improved.style.display = shouldShowImproved ? '' : 'none';

    if (!showImproved) {
      const drawerController = getSidebarDrawerController();
      if (drawerController && drawerController.isOpen()) {
        drawerController.close();
    }
    }

    const mode = showImproved ? TOP_PAGE_MODE.IMPROVED : TOP_PAGE_MODE.LEGACY;
    applyModeToBody(mode);
    if (document && document.body) {
      document.body.classList.toggle('top-page-legacy-content', forceLegacyContent);
    }
    setTopPageMode(mode);

    toggleButtons.forEach((button) => {
      const toggleText = button.querySelector('.ui-toggle-text');
      button.classList.toggle('is-on', showImproved);
      button.setAttribute('aria-pressed', showImproved ? 'true' : 'false');
      button.dataset.state = showImproved ? 'on' : 'off';
      if (toggleText) {
        toggleText.textContent = showImproved ? 'ON' : 'OFF';
      }
    });
  };

  const registerTopAnchors = () => {
    const topLinks = document.querySelectorAll('.js-improved-top-anchor');
    if (!topLinks.length) {
      return;
    }
    topLinks.forEach((link) => {
      if (link.dataset.anchorInitialized === 'true') {
        return;
      }
      link.dataset.anchorInitialized = 'true';
      link.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });
  };

  toggleButtons.forEach((button) => {
    if (button.dataset.toggleInitialized === 'true') {
      return;
    }
    button.dataset.toggleInitialized = 'true';
    button.addEventListener('click', () => {
      showImproved = !showImproved;
      forceLegacyContent = false;
      applyState();
    });
  });

  applyState();
  registerTopAnchors();

  if (forceLegacyContent || hashTargetsLegacy) {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  if ((paramMode || contentParam) && window.history && window.history.replaceState) {
    const url = new URL(window.location.href);
    if (paramMode) {
      url.searchParams.delete('top_page_mode');
    }
    if (contentParam) {
      url.searchParams.delete('top_page_content');
    }
    const newUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, '', newUrl);
  }
  initializeSidebarDrawer();
};

// Support both classic DOM ready and Turbolinks navigations.
document.addEventListener('turbolinks:load', initializeTopToggle);
document.addEventListener('DOMContentLoaded', initializeTopToggle);
